import type { JSX } from 'react'

/* The Seen Health / Orbit logo. Also exists as `apps/portal/logo.svg`
 * (used as the browser favicon). If you update one, update the other.
 *
 * a11y: decorative by default. Pass `announce` when the logo is the
 * sole brand/identity signal for screen-reader users. */
export const Logo = ({
  size = 40,
  className,
  announce = false,
}: {
  size?: number | string
  className?: string
  announce?: boolean
}): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 39 40"
    fill="none"
    className={className}
    {...(announce
      ? { role: 'img', 'aria-label': 'Seen Health' }
      : { 'aria-hidden': true, focusable: false })}
  >
    <path
      d="M33.2064 32.7323C35.5051 31.0566 38.1367 26.609 37.8848 25.135C37.57 23.2915 34.4598 22.0791 34.4166 21.4964C34.3541 20.6516 37.4346 21.3364 38.442 19.9496C39.263 18.8192 38.4107 15.0921 36.8556 12.1922C34.9783 8.69108 31.8714 5.85701 30.4665 7.50017C28.446 9.86347 27.8267 15.5781 21.0072 16.0559C20.88 16.0649 20.7825 16.111 20.7055 16.2464C20.6142 16.4073 20.5969 16.6427 20.6981 16.7279C22.0174 17.8159 26.6724 20.3594 29.2851 31.0011C29.9197 33.5854 31.1818 34.2076 33.2064 32.7323Z"
      fill="#5DC6B2"
    />
    <path
      d="M0.0370366 26.5613C0.338673 29.39 2.87481 33.8928 4.27724 34.4117C6.03109 35.0606 8.63636 32.9735 9.16227 33.2274C9.92521 33.5957 7.79194 35.9211 8.48904 37.4865C9.05733 38.7626 12.7115 39.8881 16.0003 39.9914C19.9714 40.116 23.9787 38.8428 23.2581 36.8042C22.222 33.873 17.5822 30.4789 20.5784 24.3342C20.6343 24.2194 20.643 24.112 20.5644 23.9779C20.4706 23.8186 20.2755 23.6857 20.1508 23.7309C18.5488 24.3293 14.0185 27.0889 3.49619 24.0309C0.941124 23.2882 -0.22921 24.0704 0.0366251 26.5613H0.0370366Z"
      fill="#00A7A2"
    />
    <path
      d="M21.9656 0.921379C19.3652 -0.231672 14.1975 -0.286402 13.0469 0.668301C11.6079 1.86291 12.1132 5.1624 11.6301 5.4912C10.9297 5.96773 9.98241 2.95753 8.27793 2.77852C6.88868 2.63285 4.08671 5.23442 2.3526 8.03104C0.259663 11.4079 -0.641544 15.5152 1.4839 15.9102C4.5406 16.4785 9.7997 14.1572 13.623 19.8241C13.6946 19.9298 13.7831 19.9912 13.9387 19.9899C14.1234 19.9883 14.3362 19.8858 14.3592 19.7554C14.6419 18.069 14.5172 12.7659 22.4269 5.18215C24.3474 3.34065 24.2556 1.93616 21.9656 0.920968V0.921379Z"
      fill="#A7E2C0"
    />
  </svg>
)
